import { useEffect, useRef } from "react";
import { isInsideTelegram, onMainButton, setMainButton } from "./telegram.ts";

// Нижняя кнопка Telegram одна на всё приложение, а листы могут лежать друг на друге:
// кнопкой управляет верхний (последний открытый) лист.
interface Entry {
  text: string;
  enabled: boolean;
  loading: boolean;
  click: () => void;
}

const stack: Entry[] = [];
let bound = false;

function render() {
  const top = stack.at(-1);
  if (!top) {
    setMainButton({ visible: false, loading: false });
    return;
  }
  setMainButton({ text: top.text, visible: true, enabled: top.enabled, loading: top.loading });
}

/**
 * Главное действие формы. Внутри Telegram — системная нижняя кнопка (MainButton), тогда
 * возвращает false и форма свою кнопку не рисует; в браузере возвращает true.
 */
export function useMainButton(text: string, onClick: () => void, opts: { enabled?: boolean; loading?: boolean } = {}): boolean {
  const native = isInsideTelegram();
  const enabled = opts.enabled !== false;
  const loading = !!opts.loading;
  const clickRef = useRef(onClick);
  clickRef.current = onClick;
  const entryRef = useRef<Entry | null>(null);

  useEffect(() => {
    if (!native) return;
    if (!bound) {
      onMainButton(() => stack.at(-1)?.click());
      bound = true;
    }
    const entry: Entry = { text, enabled, loading, click: () => clickRef.current() };
    entryRef.current = entry;
    stack.push(entry);
    render();
    return () => {
      const i = stack.indexOf(entry);
      if (i !== -1) stack.splice(i, 1);
      entryRef.current = null;
      render();
    };
    // Параметры обновляет эффект ниже — здесь только появление и снятие кнопки.
  }, [native]);

  useEffect(() => {
    const entry = entryRef.current;
    if (!native || !entry) return;
    Object.assign(entry, { text, enabled, loading });
    if (stack.at(-1) === entry) render();
  }, [native, text, enabled, loading]);

  return !native;
}
